import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { listItemStyle, textFieldStyle } from '../../../utils/consts/styles';

export default function FinalAttestationSelect({ defaultValue = '', disabled = false }) {
  const [value, setValue] = useState(defaultValue);

  return (
    /*
     * maxWidth обязателен. Колонка карточки (.column_style_contract) — флекс без
     * заданной ширины, поэтому она растягивается под содержимое. Это одно
     * из двух полей карточки без фиксированной ширины, и длинное значение растягивало
     * всю колонку, ломая карточку. 325px — ширина соседних полей.
     */
    <div title={value} style={{ position: 'relative', display: 'inline-block', width: '100%', maxWidth: '325px' }}>
      <TextField
        label="Итоговая аттестация"
        name="final_attestation"
        type="text"
        variant="outlined"
        color="warning"
        margin="normal"
        size="small"
        select
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        inputProps={textFieldStyle}
        InputLabelProps={textFieldStyle}
        sx={{ width: '100%' }}
      >
        <MenuItem sx={textFieldStyle} value="Сдал">
          <span style={listItemStyle}>Сдал</span>
        </MenuItem>
        <MenuItem sx={textFieldStyle} value="Не сдал">
          <span style={listItemStyle}>Не сдал</span>
        </MenuItem>
      </TextField>
      {!disabled && value && (
        <IconButton
          size="small"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setValue('');
          }}
          sx={{
            position: 'absolute',
            right: 28,
            top: '55%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
}
